module.exports = __webpack_public_path__ + "static/img/login_bg.321ed9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/yyk/login_bg.jpg
// module id = 1004
// module chunks = 30